<template>
  <div>
    <div class="flex-1 w-full text-left px-4 py-2 m-2">
      <div class="ml-auto mr-auto w-1/2 text-center">
        <div class="px-6 py-4">
          <h1>{{ getText('email_title') }}</h1>
        </div>
      </div>
      <div class="ml-auto mr-auto w-1/2 mt-20">
        <form class="w-full">
          <div class="md:flex md:items-center mb-6">
            <label class="mr-2 w-56">{{ getText('label_gender') }}</label>
            <select
              v-model="salutation"
              class="block appearance-none w-full px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
            >
              <option value>- {{ getText('label_select') }}-</option>
              <option value="F">{{ getText('label_gender_f') }}</option>
              <option value="M">{{ getText('label_gender_m') }}</option>
            </select>
          </div>

          <div class="md:flex md:items-center mb-6">
            <label class="mr-2 w-56">{{ getText('label_firstname') }}</label>
            <div class="md:w-full">
              <keyboard :options="keyboardOption" class="ui-keyboard-case" v-model="firstName"></keyboard>
            </div>
          </div>

          <div class="md:flex md:items-center mb-6">
            <label class="mr-2 w-56">{{ getText('label_lastname') }}</label>
            <div class="md:w-full">
              <keyboard :options="keyboardOption" class="ui-keyboard-case" v-model="lastName"></keyboard>
            </div>
          </div>

          <div class="md:flex md:items-center mb-6">
            <label class="mr-2 w-56">{{ getText('email_address') }}</label>
            <div class="md:w-full">
              <keyboard :options="keyboardOption" class="ui-keyboard-case" v-model="email"></keyboard>
            </div>
          </div>

          <div class="md:flex md:items-center">
            <label class="md:w-full block">
              <input class="mr-2" type="checkbox" v-model="newsletter" />
              <span>{{ getText('label_newsletter') }}</span>
            </label>
          </div>

          <div class="md:flex md:items-center mt-5">
            <label class="inline-block">
              <input class="mr-2" type="checkbox" v-model="terms" />
              <span>{{ getText('label_terms1') }}</span>
            </label>
            <a
              href="#"
              style="font-size: 14px; text-transform: uppercase; text-decoration: underline"
              class="ml-3"
              @click.prevent="showTerms"
            >{{ getText('label_terms2') }}</a>
          </div>

          <div class="md:flex md:items-center mt-20">
            <div class="md:w-full">
              <button
                class="bg-white text-black py-3 px-10 rounded-full w-full"
                type="button"
                @click="send"
                :disabled="isSending || !isFormValid()"
                :class="{ 'opacity-50 cursor-not-allowed': isSending || !isFormValid() }"
              >{{ getText('button_send') }}</button>
              <router-link to="/">
                <button
                  class="py-3 px-10 rounded-full w-full border-2 border-white text-white border-solid mt-5"
                  style="color: white !important"
                >{{ getText('button_cancel') }}</button>
              </router-link>
            </div>
          </div>
        </form>
      </div>
    </div>

    <modal name="terms-modal" :width="900" :height="600">
      <div id="terms-dialog" v-if="this.$route.params.lang == 'de'">
        <h1 class="mt-1">{{ getText('terms_of_use_title') }}</h1>
        <div style="height: 435px; overflow: auto; text-align: left">
          <h2>1. Allgemeines</h2>
          <p>Diese Datenschutzerklärung klärt den Nutzer der Anwendung über die Art, den Umfang und die Zwecke der Erhebung und Verwendung personenbezogener Daten durch Zillertal Bier (im Folgenden „Betreiber“) auf.</p>
          <p>Personenbezogene Daten (z.B. Name, E-Mail-Adresse, Telefonnummer) werden vom Betreiber nur in rechtmäßiger Weise – insbesondere zur Erfüllung vertraglicher Pflichten, aufgrund überwiegender berechtigter Interessen des Betreibers oder auf Basis der Einwilligung des Nutzers – verarbeitet und übermittelt.</p>
          <p>Sofern die Rechtmäßigkeit für eine konkrete Datenverarbeitung auf einer Einwilligung des Nutzers beruht, kann diese jederzeit (auch teilweise) durch eine E-Mail an verkauf@zillertal-bier.at widerrufen werden.</p>
          <p>Des Weiteren hat der Nutzer ein Recht auf Auskunft über die ihn betreffenden personenbezogenen Daten, auf Datenübertragbarkeit, auf Berichtigung oder Löschung personenbezogener Daten sowie auf Einschränkung der oder Widerspruch gegen die Verarbeitung seiner personenbezogenen Daten. Der Nutzer kann diese Rechte durch eine E-Mail an verkauf@zillertal-bier.at ausüben.</p>
          <p>Schließlich hat der Nutzer ein Recht auf Beschwerde bei der österreichischen Datenschutzbehörde (Hohenstaufengasse 3, 1010 Wien, dsb@dsb.gv.at, www.dsb.gv.at).</p>
          <p>Die Rechtmäßigkeit der Datenverarbeitungen ergibt sich aus dem österreichischen Datenschutzgesetz sowie aus der Verordnung (EU) 2016/679 (DSGVO). Die Rechtsgrundlage ist bei den nachstehenden Verarbeitungen jeweils konkret angegeben.</p>
          <p>Ungeachtet der unten angeführten Löschungsangaben bei den einzelnen Datenverarbeitungen unterbleibt eine Löschung insoweit, als die Verwendung der zu löschenden personenbezogenen Daten für andere rechtmäßige Verarbeitungen (zB Eigenwerbung) gemäß dieser Datenschutzerklärung herangezogen werden.</p>
          <h2>2. Eigenwerbung</h2>
          <p>Der Betreiber behält sich gemäß § 107 Abs 3 des Telekommunikationsgesetzes (TKG) und gemäß Art 6 Abs 1 lit f DSGVO vor, für eigene Werbezwecke die Daten Anrede, Vor- und Nachname, Postanschrift, E-Mail-Adresse und Telefonnummer dauerhaft zu speichern und für die Zusendung von Angeboten und Informationen zu Leistungen und Angeboten des Betreibers per Post oder per E-Mail zu nutzen. Der Nutzer kann der Verarbeitung seiner Daten zu diesem Zweck bei deren Erhebung sowie jederzeit danach durch eine E-Mail an verkauf@zillertal-bier.at widersprechen.</p>
          <h2>3. Nutzeranfragen und Aufträge</h2>
          <p>Bei der Kontaktaufnahme mit dem Betreiber (zum Beispiel per Kontaktformular oder E-Mail) werden folgende Angaben des Nutzers zwecks Bearbeitung der Anfrage bzw. Erfüllung des Auftrages sowie für den Fall, dass Anschlussfragen entstehen, verarbeitet: Anrede, Vor- und Nachname, Postanschrift, E-Mail-Adresse, Telefonnummer sowie Daten betreffend die Anfrage bzw. den Auftrag (z.B. Lieferumfang).</p>
          <p>Die so erhobenen personenbezogenen Daten werden vom Betreiber binnen vier Monaten nach Abschluss der Bearbeitung der Anfrage bzw. Erfüllung des Auftrages gespeichert und anschließend gelöscht.</p>
          <p>Die vom Nutzer bekanntgegebenen personenbezogenen Daten werden vom Betreiber nur insoweit verarbeitet und genutzt, als sie für die Bearbeitung der Anfrage und/oder die Erbringung der angeforderten Leistung erforderlich sind.</p>
          <p>Im Zuge dieser Datenverarbeitung leitet der Betreiber die erhobenen personenbezogenen Daten Anrede, Vor- und Nachname, Postanschrift, E-Mail-Adresse, Telefonnummer sowie Daten betreffend Auftrag oder Anfrage an folgende Dritte weiter:</p>
          <ul>
            <li>
              Orga Soft
              <br />ORGA-SOFT Organisation und Software GmbH
              <br />Nikolaus-Kopernikus-Straße 7
              <br />55129 Mainz
              <br />Deutschland
              <br />Website: www.orga-soft.de
              <br />Datenschutzerklärung: www.orga-soft.de/datenschutz
              <br />
            </li>
            <li>
              Com-Plett
              <br />Klocker Hannes
              <br />Juns 621
              <br />6293 Tux
              <br />Österreich
              <br />office@com-plett.com
              <br />
            </li>
          </ul>
          <p>Der Betreiber bedient sich der angeführten Unternehmen als Auftragsverarbeiter zum Zwecke der Vertragserfüllung.</p>
          <p>Die Datenverarbeitung ist gemäß Art 6 Abs 1 lit b DSGVO zur Vertragserfüllung bzw. zur Durchführung vorvertraglicher Maßnahmen erforderlich und für den Betreiber von überwiegendem berechtigten Interesse.</p>
          <h2>4. Newsletter</h2>
          <p>Wenn ein Nutzer den Newsletter des Betreibers abonniert, werden personenbezogene Daten des Nutzers, nämlich Anrede, Vor- und Nachname, die E-Mail-Adresse sowie Geburtsdatum und Geschlecht (als freiwillige Angabe) erhoben und verarbeitet. Der Nutzer erhält dann bis zu einmal pro Tag eine personalisierte E-Mail mit auf seine Bedürfnisse ausgerichteten Informationen und Angeboten des Betreibers (Newsletter).</p>
          <p>Durch das Abonnieren des Newsletters erteilt der Nutzer gemäß Art 6 Abs 1 lit a DSGVO seine schlüssige Einwilligung, dass seine Daten für die regelmäßige Zusendung des Newsletters verwendet werden dürfen.</p>
          <p>Für die Registrierung wird das Double-Opt-In-Verfahren verwendet. Nach der Anmeldung erhält der Nutzer auf die von ihm angegebene E-Mail-Adresse eine Bestätigungs- und Autorisierungs-E-Mail mit der Aufforderung, den darin enthaltenen Link anzuklicken. Damit wird sichergestellt, dass sich nur der berechtigte Nutzer der angegeben E-Mail-Adresse für den Newsletter anmelden kann.</p>
          <p>Der Nutzer kann den Newsletter jederzeit abbestellen. Am Ende jedes Newsletters befindet sich ein Link, über den der Nutzer die Abbestellung vornehmen kann. Alternativ kann der Nutzer auch eine entsprechende E-Mail an verkauf@zillertal-bier.at senden. Nach Abbestellung des Newsletters werden die personenbezogenen Daten des Nutzers binnen vier Monaten aus dem Newsletter-Verteiler gelöscht.</p>
          <p>Im Zuge der Datenverarbeitung sind die oben angegebenen persönlichen Daten folgenden Dritten zugänglich:</p>
          <ul>
            <li>
              ZIMMERMANN PUPP WERBEAGENTUR
              <br />Hunoldstraße 12
              <br />6020 Innsbruck
              <br />Österreich
              <br />Website: www.zimmermann-pupp.com
              <br />Datenschutzerklärung: www.zimmermann-pupp.com/service/datenschutz
              <br />
            </li>
            <li>
              CleverReach GmbH &amp; Co. KG
              <br />Mühlenstr. 43
              <br />26180 Rastede
              <br />Deutschland
              <br />Website: www.cleverreach.com/de
              <br />Datenschutzerklärung: www.cleverreach.com/de/datenschutz/
              <br />
            </li>
          </ul>
          <p>Der Betreiber bedient sich der angeführten Unternehmen als Auftragsverarbeiter zum Zwecke des Newsletterversandes.</p>
        </div>
        <button
          class="py-5 px-40 rounded-full mt-10"
          style="color: white !important; background-color: #544B45"
          @click="hideTerms"
        >OK</button>
      </div>
      <div id="terms-dialog" v-if="this.$route.params.lang == 'en'">
        <h1 class="mt-1">{{ getText('terms_of_use_title') }}</h1>
        <div style="height: 435px; overflow: auto; text-align: left">
          <h2>1. General</h2>
          <p>This data protection declaration clarifies the user of the application about the type, scope and purpose of the collection and use of personal data by Zillertal Bier (hereinafter "Operator").</p>
          <p>Personal data (e.g. name, e-mail address, telephone number) are only processed and transmitted by the operator in a lawful manner - in particular to fulfil contractual obligations, due to the operator's overriding legitimate interests or on the basis of the user's consent.</p>
          <p>If the legality for specific data processing is based on the consent of the user, this can be revoked at any time (also partially) by sending an e-mail to verkauf@zillertal-bier.at.</p>
          <p>Furthermore, the user has the right to information about the personal data concerning him, to data portability, to correction or deletion of personal data as well as to restrict or object to the processing of his personal data. The user can exercise these rights by e-mailing verkauf@zillertal-bier.at.</p>
          <p>Finally, the user has the right to lodge a complaint with the Austrian data protection authority (Hohenstaufengasse 3, 1010 Vienna, dsb@dsb.gv.at, www.dsb.gv.at).</p>
          <p>The legality of data processing results from the Austrian Data Protection Act and from Regulation (EU) 2016/679 (GDPR). The legal basis is given specifically for the processing below.</p>
          <p>Regardless of the deletion information given below for the individual data processing operations, deletion does not take place insofar as the use of the personal data to be deleted is used for other lawful processing operations (e.g. self-promotion) in accordance with this data protection declaration.</p>
          <h2>2. Self-promotion</h2>
          <p>In accordance with Section 107 (3) of the Telecommunications Act (TKG) and Article 6 (1) (f) GDPR, the operator reserves the right to permanently store the salutation, first and last name, postal address, e-mail address and telephone number for its own advertising purposes and to send offers and information on the operator's services and offers by post or e-mail. The user can object to the processing of their data for this purpose when they are collected and at any time afterwards by sending an e-mail to verkauf@zillertal-bier.at.</p>
          <h2>3. User requests and orders</h2>
          <p>When contacting the operator (e.g. via contact form or e-mail), the following information from the user is processed for the purpose of processing the request or fulfilling the order and in the event that follow-up questions arise: title, first and last name, postal address, e-mail address, telephone number and data relating to the request or order (e.g. scope of delivery).</p>
          <p>The personal data collected in this way will be saved by the operator within four months after completion of the processing of the request or fulfilment of the order and then deleted.</p>
          <p>The operator will process and use the personal data provided by the user only to the extent necessary to process the request and / or to provide the requested service.</p>
          <p>In the course of this data processing, the operator forwards the personal data collected, title, first and last name, postal address, e-mail address, telephone number and data regarding the order or request to the following third parties:</p>
          <ul>
            <li>
              Orga Soft
              <br />ORGA-SOFT Organisation und Software GmbH
              <br />Nikolaus-Kopernikus-Straße 7
              <br />55129 Mainz
              <br />Germany 
              <br />Website: www.orga-soft.de
              <br />Data Privacy Policy: www.orga-soft.de/datenschutz
              <br />
            </li>
            <li>
              Com-Plett
              <br />Klocker Hannes
              <br />Juns 621
              <br />6293 Tux
              <br />Austria
              <br />office@com-plett.com
              <br />
            </li>
          </ul>
          <p>The operator uses the listed companies as processors for the purpose of fulfilling the contract.</p>
          <p>Data processing is required in accordance with Art.6 Para. 1 b GDPR for the fulfilment of the contract or for the implementation of pre-contractual measures and of overriding legitimate interest for the operator.</p>
          <h2>4. Newsletter</h2>
          <p>If a user subscribes to the operator's newsletter, personal data of the user, namely title, first and last name, e-mail address and date of birth and gender (as voluntary information) are collected and processed. The user then receives a personalised e-mail up to once a day with information and offers from the operator tailored to his needs (newsletter).</p>
          <p>By subscribing to the newsletter, the user gives his conclusive consent in accordance with Art 6 Para 1 lit a GDPR that his data may be used for the regular sending of the newsletter.</p>
          <p>The double opt-in procedure is used for registration. After registration, the user will receive confirmation and authorisation e-mail at the e-mail address he has given, asking him to click on the link contained therein. This ensures that only the authorised user of the specified e-mail address can register for the newsletter.</p>
          <p>The user can unsubscribe from the newsletter at any time. At the end of each newsletter there is a link through which the user can unsubscribe. Alternatively, the user can also send an e-mail to verkauf@zillertal-bier.at. After unsubscribing from the newsletter, the user's personal data will be deleted from the newsletter distribution list within four months.</p>
          <p>In the course of data processing, the personal data specified above are accessible to the following third parties:</p>
          <ul>
            <li>
              ZIMMERMANN PUPP WERBEAGENTUR
              <br />Hunoldstraße 12
              <br />6020 Innsbruck
              <br />Austria
              <br />Website: www.zimmermann-pupp.com
              <br />Data Privacy Policy: www.zimmermann-pupp.com/service/datenschutz
              <br />
            </li>
            <li>
              CleverReach GmbH &amp; Co. KG
              <br />Mühlenstr. 43
              <br />26180 Rastede
              <br />Germany
              <br />Website: www.cleverreach.com/de
              <br />Data Privacy Policy: www.cleverreach.com/de/datenschutz/
              <br />
            </li>
          </ul>
          <p>The operator uses the listed companies as processors for the purpose of sending the newsletter.</p>
        </div>
        <button
          class="py-5 px-40 rounded-full mt-10"
          style="color: white !important; background-color: #544B45"
          @click="hideTerms"
        >OK</button>
      </div>
    </modal>
  </div>
</template>

<style scoped>
h1 {
  font-family: FoundryWilsonMedium;
  font-size: 66px;
  margin-top: 90px;
  text-transform: uppercase;
}

select {
  font-family: FoundryWilsonNormal;
  font-size: 24px;
  background: white;
  color: black;
}

input {
  font-family: FoundryWilsonNormal;
  font-size: 24px;
  color: black;
}

label {
  text-transform: uppercase;
  font-size: 14px;
}

#terms-dialog {
  font-family: FoundryWilsonMedium;
  font-size: 14px;
  text-align: center;
  padding: 20px;
  width: 900px;
  height: 600px;
  background: white;
  color: #544b45;
  letter-spacing: 1px;
  text-align: center;
}

#terms-dialog h1 {
  text-transform: uppercase;
  font-family: FoundryWilsonMedium;
  font-size: 33px;
  line-height: 100%;
  color: #544b45;
  margin-top: 10px;
  margin: 10px 0;
}

#terms-dialog h2 {
  text-transform: uppercase;
  font-family: FoundryWilsonMedium;
  font-size: 20px;
}

#terms-dialog ul {
  list-style-type: circle;
  margin-left: 20px;
}

#terms-dialog ul > li {
  margin-bottom: 10px;
}

#terms-dialog button {
  text-transform: uppercase;
  width: 760px;
  padding: 10px;
  margin-top: 15px;
}
</style>

<script>
import axios from "axios";
import { Keyboard } from "vue-virtual-keyboard";

export default {
  name: "Email",

  components: {
    Keyboard
  },

  methods: {
    getText(key) {
      return this.$settings.interface[key][this.$route.params.lang];
    },

    capitalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },

    send: function() {
      this.isSending = true;
      this.firstName = this.capitalize(this.firstName);
      this.lastName = this.capitalize(this.lastName);
      axios
        .post(`${process.env.VUE_APP_VIDEO_SERVICE_URL}api/Mail/send`, {
          to: this.email,
          subject: this.subject(),
          body: this.body(),
          salutation: this.salutation,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          newsletter: this.newsletter,
          attachmentPath: this.$variables.videoPath
        })
        .then(() => {
          this.isSending = false;
          this.$router.push({
            name: "goodbye",
            params: { lang: this.$route.params.lang }
          });
        });
    },

    subject: function() {
      return this.$settings.interface["email_subject"][this.$route.params.lang];
    },

    body: function() {
      let salutation =
        this.salutation == "F"
          ? this.$route.params.lang == "en"
            ? "Dear " + this.firstName
            : "Liebe " + this.firstName
          : this.$route.params.lang == "en"
          ? "Dear " + this.firstName
          : "Lieber " + this.firstName;
      let body = this.$settings.interface["email_body"][
        this.$route.params.lang
      ];
      return body.replace("#salutation", salutation);
    },

    showTerms() {
      this.$modal.show("terms-modal");
    },

    hideTerms() {
      this.$modal.hide("terms-modal");
    },

    isValidEmail(address) {
      var reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
      return reg.test(address);
    },

    isFormValid() {
      return (
        this.isValidEmail(this.email) &&
        this.salutation &&
        this.firstName &&
        this.lastName &&
        this.terms
      );
    }
  },

  data() {
    return {
      salutation: "",
      firstName: "",
      lastName: "",
      email: "",
      newsletter: true,
      terms: false,
      isSending: false,
      keyboardOption: {
        usePreview: false,
        stickyShift: false,
        autoAccept: true,
        language: "de",
        display: {},
        layout: "custom",
        customLayout: {
          normal: [
            "1 2 3 4 5 6 7 8 9 0 {b}",
            "@ q w e r t z u i o p ü",
            "a s d f g h j k l ö ä",
            "y x c v b n m . - _"
          ]
        }
      }
    };
  }
};
</script>
